import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { registerFilesUi } from 'consilium-files-ui';

// Импортируем переводы
import enTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';
import hyTranslations from './locales/hy.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
  hy: {
    translation: hyTranslations,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'hy',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'elitmed-language',
      caches: ['localStorage'],
    },
  });

// Тексты окна «Файлы приёма» (пространство `files-ui`, ru/en/hy) из общего пакета.
registerFilesUi(i18n);

export default i18n;